<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control checkbox-list-input" :class="config.cssClass">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <ul class="checkboxes-container" :class="{'row-direction': config.showInline}" :style="{ height: config.height }">
                <li v-for="(option,index) in options" :key="index" class="checkbox-wrapper">
                    <ejs-radiobutton
                        v-bind="option"
                        :label="ddStoreFilter(option[labelKey])"
                        :checked="option[valueKey] === value"
                        :value="option[valueKey]"
                        v-on:click="action($event, 'onclick')"
                        v-on:change="listChanges(option.value); action($event, 'onchange')"
                        :ref="config.ref || config.id"
                        :data-test-id="dataTestId + '_' + index"
                        :disabled="config.disabled"
                    ></ejs-radiobutton>
                    <sam-tooltip
                        v-if="option.helpText"
                        ref="tooltip"
                        opensOn="Click"
                        class="checkbox-tooltip"
                        :css-class="tooltipSettings.tooltipClasses"
                        :content="option.helpText"
                        :show-with-empty-label="tooltipSettings.showWithEmptyLabel"
                        :label-classes="tooltipSettings.tooltipLabelClasses"
                    ></sam-tooltip>
                    <br/>
                    <div v-if="option.note">{{option.note}}</div>
                </li>
            </ul>
            <p v-if="config.message" class="input-info" v-html="ddStoreFilter(config.message)"></p>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    showInline: {
        type: 'boolean',
        label: 'Show inline',
        default: false
    }
};

export const radioButtonComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    methods: {
        listChanges(value) {
            this.value = value;
            if (this.$parent && this.$parent.$attrs) {
                this.$parent.$emit('update:value', value);
            }
        }
    },
    computed: {
        valueKey() {
            return (this.config && this.config.fields && this.config.fields.value) || 'value';
        },
        labelKey() {
            return (this.config && this.config.fields && this.config.fields.text) || 'label';
        },
        tooltipSettings() {
            let tooltipId = (this.name || this.id) + '_tooltip';
            let tooltipPosition = ' TopCenter';
            return {
                tooltipClasses: 'label-wrapper-tooltip ' + tooltipId + tooltipPosition,
                tooltipLabelClasses: 'e-icons e-info help-tooltip ' + tooltipId,
                showWithEmptyLabel: true
            };
        }
    },
    components: {
        "ejs-radiobutton": defineAsyncComponent(() => import('@common/syncfusion/radioButton')),
        "sam-tooltip": defineAsyncComponent(() => import('@common/control/samTooltip')),
    }
};

export default radioButtonComponent;
</script>

<style lang="css" scoped>
.checkbox-list-input {
    margin: 5px 0 !important;
}
.checkboxes-container {
    display: flex;
    flex-direction: column;
    padding: 5px 0 0 10px;
    flex-wrap: wrap;
}
.checkboxes-container.row-direction {
    flex-direction: row;
    padding: 0;
    margin: 0;
}
.checkbox-wrapper {
    margin: 5px 20px 5px 10px;
    list-style: none;
}
.checkbox-wrapper .checkbox-tooltip {
    margin-left: 5px;
}
.input-info {
    color: #2973b7;
}

</style>
